import { useMutation, useQuery } from "@tanstack/react-query";
import lipaBidhaaService from "../../services/api/lipaBidhaaService";
import { POLL_INTERVAL_MS } from "../../components/LipaBidhaa/config/lipaBidhaaConfig";

export const lipaBidhaaQueryKeys = {
  all: ["lipaBidhaa"],
  verifyMerchant: () => [...lipaBidhaaQueryKeys.all, "verifyMerchant"],
  charges: () => [...lipaBidhaaQueryKeys.all, "charges"],
  payment: () => [...lipaBidhaaQueryKeys.all, "payment"],
  verification: () => [...lipaBidhaaQueryKeys.all, "verification"],
  resendOtp: () => [...lipaBidhaaQueryKeys.all, "resendOtp"],
  transaction: (transactionUuid) => [
    ...lipaBidhaaQueryKeys.all,
    "transaction",
    transactionUuid,
  ],
};

export const useVerifyLipaBidhaaMerchant = () => {
  return useMutation({
    mutationFn: ({ paymentType, alias }) =>
      lipaBidhaaService.verifyMerchant({ paymentType, alias }),
    mutationKey: lipaBidhaaQueryKeys.verifyMerchant(),
  });
};

export const useLipaBidhaaCharges = () => {
  return useMutation({
    mutationFn: (payload) => lipaBidhaaService.queryCharges(payload),
    mutationKey: lipaBidhaaQueryKeys.charges(),
  });
};

export const useLipaBidhaaPayment = () => {
  return useMutation({
    mutationFn: (payload) => lipaBidhaaService.requestPayment(payload),
    mutationKey: lipaBidhaaQueryKeys.payment(),
  });
};

export const useLipaBidhaaVerification = () => {
  return useMutation({
    mutationFn: ({ otp }) => lipaBidhaaService.verifyOtp({ otp }),
    mutationKey: lipaBidhaaQueryKeys.verification(),
  });
};

export const useLipaBidhaaResendOtp = () => {
  return useMutation({
    mutationFn: (transactionUuid) => lipaBidhaaService.resendOtp(transactionUuid),
    mutationKey: lipaBidhaaQueryKeys.resendOtp(),
  });
};

export const useLipaBidhaaTransaction = (
  transactionUuid,
  { enablePolling = true } = {},
) => {
  return useQuery({
    queryKey: lipaBidhaaQueryKeys.transaction(transactionUuid),
    queryFn: () => lipaBidhaaService.getTransaction(transactionUuid),
    enabled: !!transactionUuid,
    staleTime: 0,
    retry: false,
    refetchInterval: enablePolling ? POLL_INTERVAL_MS : false,
  });
};
